<template>
	<div>
		<transition appear name="fadezoom">
			<div class="image-container">
				<image-slider></image-slider>
			</div>
		</transition>

		<transition appear name="fade">
			<navigation :darken="false"></navigation>
		</transition>

		<transition appear name="fadeslow">
			<div class="footer">
				<router-link to="contact">{{ copyright }}</router-link>
			</div>
		</transition>

	</div>
</template>

<script>

	import ImageSlider from "./ImageSlider.vue";
	import Navigation from "./Navigation.vue";

	export default {
		name: 'Main',
		components: {
			ImageSlider,
			Navigation
		},
		data () {
			return {
				copyright: '© TABI | ROBERTO@TABI.SE | STOCKHOLM, SWEDEN'
			}
		}
	}
</script>

<style lang="scss" scoped>

	$font-color: #f0f0f0;
	$font-hover-color: #fff;

	.image-container {
		position: absolute;
		z-index: -1;
		width: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		margin: 0;
		padding: 0;
	}

	/* router-link generates <a> */
	.footer {
		position: fixed;
		text-align: center;
		bottom: 0;
		right: 0;
		width: 100%;
		margin-bottom: 0.20rem;
	}

	a {
		font-size: 0.6rem;
		font-weight: 100;
		color: $font-color;
		text-decoration: none;
	}

	a:hover, li:hover {
		color: $font-hover-color;
		cursor: pointer;
		font-weight: 400;
	}

	@media only screen and (min-width: 600px) {
		h3 {
			font-size: 0.7rem;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Main.vue